export default "__VITE_ASSET__B5$k3fOI__"